import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromFeed from './feed.reducer';

export const reducers = fromFeed.reducer;

export const selectCatalogState = createFeatureSelector('feed');

export const getState = createSelector(selectCatalogState, fromFeed.getState);
